// src/api.js
import axios from "axios";

// 1️⃣ Create your instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json-patch+json",
    Accept: "*/*",
  },
});

// 2️⃣ Request interceptor — attach the token
api.interceptors.request.use(
  (config) => {
    const saved = JSON.parse(localStorage.getItem("user"));
    const token = saved?.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 3️⃣ Response interceptor — watch for expired / unauthorized
api.interceptors.response.use(
  (response) => response, // pass through on success
  async (error) => {
    const originalRequest = error.config;

    // if your API returns 401 when the token is invalid/expired:
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Try to refresh the token
        const saved = JSON.parse(localStorage.getItem("user"));
        if (saved?.refreshToken) {
          const refreshResponse = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/v1/Auth/refreshtoken`,
            { refreshToken: saved.refreshToken },
            {
              headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "*/*",
              },
            }
          );

          if (refreshResponse.data?.accessToken) {
            // Update localStorage with new tokens
            saved.accessToken = refreshResponse.data.accessToken;
            saved.refreshToken =
              refreshResponse.data.refreshToken || saved.refreshToken;
            localStorage.setItem("user", JSON.stringify(saved));

            // Update the Authorization header for the original request
            originalRequest.headers.Authorization = `Bearer ${refreshResponse.data.accessToken}`;

            // Retry the original request
            return api(originalRequest);
          }
        }
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
      }

      // If refresh failed or no refresh token, logout
      localStorage.removeItem("user");
      window.location.href = "/login";
    }

    // always reject so the calling code can still see the error if it wants
    return Promise.reject(error);
  }
);

export default api;
